import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import config from 'universal-config';
import { decorateWith, withName } from 'helpers/decorator';
import { setAvailable, setLoading } from './optimizely.saga';
export var OptimizelySDKUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(OptimizelySDKUnwrapped, _Component);

  function OptimizelySDKUnwrapped() {
    _classCallCheck(this, OptimizelySDKUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizelySDKUnwrapped).apply(this, arguments));
  }

  _createClass(OptimizelySDKUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.constructor.hasInitialized) {
        this.constructor.hasInitialized = true;
        this.props.setLoading(); // Ensure a "push" interface

        window.optimizely = window.optimizely || []; // Optimizely might take awhile to load.  We want to know when it finishes

        window.optimizely.push({
          type: 'addListener',
          filter: {
            type: 'lifecycle',
            name: 'initialized'
          },
          handler: this.props.setAvailable
        }); // Optimizely may have loaded before the listener was in place to fire

        if (!Array.isArray(window.optimizely)) {
          this.props.setAvailable();
        } // Check eligibility for experiments on each page change


        document.body.addEventListener('historyChanged', function () {
          return window.optimizely.push({
            type: 'activate'
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Helmet, null, React.createElement("link", {
        rel: "prefetch",
        href: "https://cdn.optimizely.com/js/".concat(config().optimizely.projectId, ".js")
      }), React.createElement("link", {
        rel: "preconnect",
        href: "//logx.optimizely.com"
      }));
    }
  }]);

  return OptimizelySDKUnwrapped;
}(Component);
OptimizelySDKUnwrapped.hasInitialized = false;
OptimizelySDKUnwrapped.propTypes = {
  setAvailable: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired
};
export var OptimizelySDK = decorateWith(connect(null, {
  setAvailable: setAvailable,
  setLoading: setLoading
}), withName('OptimizelySDK'))(OptimizelySDKUnwrapped);